import React from "react";
import { SmallSwitch } from "components/common/styled";
import { SettingItem, SettingLine, SettingTitle } from "./styled";
import cs from "classnames";

import {
  UserPreferenceSettingEnum,
  useUserPreferenceSetting,
} from "store/data/User";
import { useRecoilState } from "recoil";
import TimezoneSetting from "./TimezoneSetting";

// 现货配置
import { SUPPORT_LAYOUT } from "constants/layout";
import { MixSpotLayoutState } from "store/data/Spot";
import styles from "./index.module.less";
import LocalCache, { CacheKey } from "util/LocalCache";

import rightDark from "assets/img/spot/layout-right-black.svg";
import rightWhite from "assets/img/spot/layout-right-white.svg";

import leftDark from "assets/img/spot/layout-left-black.svg";
import leftWhite from "assets/img/spot/layout-left-white.svg";

import centerDark from "assets/img/spot/layout-center-black.svg";
import centerWhite from "assets/img/spot/layout-center-white.svg";
import { useMyIntl } from "hooks";
import { FormattedMessage } from "react-intl";

interface SettingDialogProps {
  theme: string;
  userId: string;
}
const SettingDialog: React.FC<SettingDialogProps> = (props) => {
  const { theme, userId } = props;
  const [userPreferenceSetting, setUserPreferenceSetting] =
    useUserPreferenceSetting();
  const [layout, setLayout] = useRecoilState(MixSpotLayoutState);

  const t = useMyIntl();

  const handleUpdateUserPreference = (value: boolean, type: string) => {
    setUserPreferenceSetting({ [type]: Number(value) });
  };

  // 渲染登陆部分
  const renderLoginPart = () => {
    return (
      <>
        {/* 下单二次确认 */}
        <SettingItem>
          <span className={"setting-item-part"}>
            <FormattedMessage
              id={"user_preference.confirm_title_tip"}
              defaultMessage={"Trading Ayarları"}
            />
          </span>
          <span>
            <SmallSwitch
              checked={
                !userPreferenceSetting[
                  UserPreferenceSettingEnum.SPOT_NORMAL_ENTRUST
                ]
              }
              onChange={(checked) => {
                handleUpdateUserPreference(
                  !checked,
                  UserPreferenceSettingEnum.SPOT_NORMAL_ENTRUST
                );
              }}
            />
          </span>
        </SettingItem>
        {/* 计划委托二次确认 */}
        <SettingItem>
          <span className={"setting-item-part"}>
            <FormattedMessage
              id={"user_preference.confirm_plan"}
              defaultMessage={"Tetik emrinin ikinci onayı"}
            />
          </span>
          <span>
            <SmallSwitch
              checked={
                !userPreferenceSetting[
                  UserPreferenceSettingEnum.SPOT_PLAN_ENTRUST
                ]
              }
              onChange={(checked) => {
                handleUpdateUserPreference(
                  !checked,
                  UserPreferenceSettingEnum.SPOT_PLAN_ENTRUST
                );
              }}
            />
          </span>
        </SettingItem>
        {/*  现货成交通知 */}

        <SettingItem>
          <span className={"setting-item-part"}>
            <FormattedMessage
              id={"spot_closing_notice.xhtz"}
              defaultMessage={"现货成交通知"}
            />
          </span>
          <span>
            <SmallSwitch
              checked={
                !userPreferenceSetting[UserPreferenceSettingEnum.SPOT_POPUP]
              }
              onChange={(checked) => {
                handleUpdateUserPreference(
                  !checked,
                  UserPreferenceSettingEnum.SPOT_POPUP
                );

                handleUpdateUserPreference(
                  !checked,
                  UserPreferenceSettingEnum.SPOT_NOTICE
                );
              }}
            />
          </span>
        </SettingItem>

        {/* 现货成交提示声 */}
        <SettingItem>
          <span className={"setting-item-part"}>
            <FormattedMessage
              id={"spot_closing_notice.xh"}
              defaultMessage={"现货成交提示声"}
            />
          </span>
          <span>
            <SmallSwitch
              checked={
                !userPreferenceSetting[UserPreferenceSettingEnum.SPOT_NOTICE]
              }
              onChange={(checked) => {
                handleUpdateUserPreference(
                  !checked,
                  UserPreferenceSettingEnum.SPOT_NOTICE
                );
              }}
            />
          </span>
        </SettingItem>
      </>
    );
  };

  return (
    <>
      <SettingTitle> {t("closing_notice.tz", "通知设置")}</SettingTitle>
      {userId ? renderLoginPart() : null}
      <SettingLine></SettingLine>
      {/* 时区 涨跌幅 */}
      <TimezoneSetting></TimezoneSetting>
    </>
  );
};

export default SettingDialog;
